'use strict';

var FontFaceObserver = require('fontfaceobserver');

// Constructor
var FontfaceHandler = function() {

  var self = this;

  // https://www.filamentgroup.com/lab/font-events.html
  // https://github.com/bramstein/fontfaceobserver

  // ---------------------------------------------
  // Classes added to <html>:
  //
  // .fl-sans
  // .fl-sans-italic
  // .fl-sans-bold
  // .fl-sans-bold-italic
  // .fl-sans-medium
  // .fl-sans-medium-italic
  // .fl-sans-light
  // .fl-sans-light-italic
  //
  // ---------------------------------------------

  self.config = {
    fonts: [
      {
        className: 'fl-sans',
        observer: new FontFaceObserver('Atlas Grotesk')
      },
      {
        className: 'fl-sans-italic',
        observer: new FontFaceObserver('Atlas Grotesk', {
          weight: 400,
          style: 'italic'
        })
      },
      {
        className: 'fl-sans-light',
        observer: new FontFaceObserver('Atlas Grotesk', {
          weight: 300
        })
      },
      {
        className: 'fl-sans-light-italic',
        observer: new FontFaceObserver('Atlas Grotesk', {
          weight: 300,
          style: 'italic'
        })
      },
      {
        className: 'fl-sans-medium',
        observer: new FontFaceObserver('Atlas Grotesk', {
          weight: 500
        })
      },
      {
        className: 'fl-sans-medium-italic',
        observer: new FontFaceObserver('Atlas Grotesk', {
          weight: 500,
          style: 'italic'
        })
      },
      {
        className: 'fl-sans-bold',
        observer: new FontFaceObserver('Atlas Grotesk', {
          weight: 700
        })
      },
      {
        className: 'fl-sans-bold-italic',
        observer: new FontFaceObserver('Atlas Grotesk', {
          weight: 700,
          style: 'italic'
        })
      },
      {
        className: 'fl-sans-black',
        observer: new FontFaceObserver('Atlas Grotesk', {
          weight: 900
        })
      },
      {
        className: 'fl-sans-black-italic',
        observer: new FontFaceObserver('Atlas Grotesk', {
          weight: 900,
          style: 'italic'
        })
      }
    ]
  }

  self.parseFontConfig = function() {

    self.config.fonts.forEach(function(font) {

      Promise.all(
        [
          font.observer.load()
        ]
      ).then(function() {
        document.documentElement.className += ' ' + font.className;
      });
    });
  }

  self.setCookie = function() {
    document.cookie = 'fonts-loaded=true';
  }

  self.init = function() {
    self.parseFontConfig();
    self.setCookie();
  }
};

module.exports = FontfaceHandler;
